import React from "react";
import { Link } from "@reach/router";

import "./style.scss";

const Schedule = ({
  season,
  beach,
  year,
  children,
  start,
  end,
  removeThru,
  download,
  alert,
  multipleStops = false,
}) => {
  const fileName = `${beach}${season}${start}-${year}`.replace(/\s/g, "");
  return (
    <div className="container page schedule d-print-block">
      <span className="page-stripe">
        {/* <span className='debut-texture' /> */}
      </span>
      <div className="content">
        <div className="schedule-title row">
          <div className="col-md-8">
            <h2>
              <span className="schedule-beach">{beach}</span> {season} {year}
            </h2>
            <h1>
              {start} {!removeThru && "thru"} {end}
            </h1>
          </div>
          <div className="col-md-4 text-right d-print-none">
            <Link
              className="btn btn-outline-primary mr-2"
              to="/info/passenger-freight/"
            >
              <i className="far fa-info-circle mr-1" />
              View Freight Policy
            </Link>
            {download && (
              <a
                className="btn btn-outline-primary"
                href={download}
                target="_blank"
              >
                <i className="far fa-print mr-1" />
                Print
              </a>
            )}
            {!download && (
              <button
                className="btn btn-outline-primary"
                onClick={() => {
                  document.title = fileName;
                  window.print();
                }}
              >
                <i className="far fa-print mr-1" />
                Print
              </button>
            )}
          </div>
        </div>
        {alert && <div className="row">{alert}</div>}

        <div className="row justify-content-center">{children}</div>
        {multipleStops && (
          <div className="text-center">
            <i className="far fa-exclamation-circle" /> Most Trips Will Make
            Multiple Stops
          </div>
        )}
      </div>
    </div>
  );
};

const Panel = ({ title, children, beach, note, note2, note3, after }) => (
  <div className="col-lg-6 col-print-6 schedule-panel">
    <div className="schedule-well">
      <h2>{title}</h2>
      {note && (
        <h3 className="mb-2 text-danger">
          <i className="far fa-exclamation-circle" /> {note}
        </h3>
      )}
      {note2 && (
        <h3 className="mb-2">
          <i className="far fa-exclamation-circle" /> {note2}
        </h3>
      )}
      {note3 && (
        <h3 className="mb-2">
          <i className="fas fa-location-arrow" /> {note3}
        </h3>
      )}
      {children && (
        <>
          <table className="table table-sm">
            <thead>
              <tr>
                <th>
                  <span className="text-nowrap">
                    Bay Shore{" "}
                    <i className="text-secondary far fa-angle-double-right" />
                  </span>{" "}
                  <span className="text-nowrap">{beach}</span>
                </th>
                <th className="text-right">
                  <span className="text-nowrap">
                    {beach}{" "}
                    <i className="text-secondary far fa-angle-double-right" />
                  </span>{" "}
                  <span className="text-nowrap">Bay Shore</span>
                </th>
              </tr>
            </thead>
          </table>
          <table className="table table-sm">
            <tbody>{children}</tbody>
          </table>
        </>
      )}

      {after && <div className="mt-3 text-center">{after}</div>}
    </div>
  </div>
);

const Alert = ({ children, icon, danger }) => (
  <div
    className={`col-sm-12 alert-panel ${danger ? "alert-panel-danger" : ""}`}
  >
    <div className="schedule-well">
      <h2>
        {icon && <i className={`${icon}`} />} {children}
      </h2>
    </div>
  </div>
);

const SpecialSchedule = ({ title, icon, children }) => (
  <div className="col-lg-6 schedule-panel">
    <div className="schedule-well">
      <h2>
        {icon && <i className={`${icon} mr-2`} />}
        {title}
      </h2>
      <table className="table table-sm">
        <tbody>{children}</tbody>
      </table>
    </div>
  </div>
);

const Line = ({ children }) => <tr>{children}</tr>;

const Trip = ({
  time,
  BS,
  peak,
  legend,
  star,
  diamond,
  circle,
  square,
  cancelled,
}) => (
  <td
    className={`${peak ? "peak" : ""} ${
      BS ? "text-left" : "text-right"
    } trip-time ${cancelled ? "trip-cancelled" : ""}`}
  >
    {legend && !BS && (
      <span className="mr-1">
        <Badge>{legend}</Badge>
      </span>
    )}
    {star && !BS && (
      <span className="mr-1 asterisk">
        <Star />
      </span>
    )}
    {square && !BS && (
      <span className="mr-1 asterisk">
        <Square />
      </span>
    )}
    {diamond && !BS && (
      <span className="mr-1 asterisk">
        <Diamond />
      </span>
    )}
    {circle && !BS && (
      <span className="mr-1 asterisk">
        <Circle />
      </span>
    )}
    {time}
    {star && BS && (
      <span className="ml-1 asterisk">
        <Star />
      </span>
    )}
    {square && BS && (
      <span className="ml-1 asterisk">
        <Square />
      </span>
    )}
    {diamond && BS && (
      <span className="ml-1 asterisk">
        <Diamond />
      </span>
    )}
    {circle && BS && (
      <span className="ml-1 asterisk">
        <Circle />
      </span>
    )}
    {legend && BS && (
      <span className="ml-1">
        <Badge>{legend}</Badge>
      </span>
    )}
  </td>
);

const Legend = ({ children }) => (
  <div className="col-lg-6 schedule-panel">
    <div className="schedule-well text-center">
      <h2>Legend</h2>
      {children}
    </div>
  </div>
);

const Badge = ({ children }) => (
  <span className="badge badge-light badge-legend">{children}</span>
);

const Star = () => <i className="fas fa-star" />;

const Square = () => <i className="fas fa-square" />;
const Diamond = () => <i className="fas fa-diamond" />;
const Circle = () => <i className="fas fa-circle" />;
const LegendItem = ({ legend, description }) => (
  <div>
    <Badge>{legend}</Badge> - {description}
  </div>
);
const StarItem = ({ description }) => (
  <div>
    <Star /> - {description}
  </div>
);
const SquareItem = ({ description }) => (
  <div>
    <Square /> - {description}
  </div>
);
const DiamondItem = ({ description }) => (
  <div>
    <Diamond /> - {description}
  </div>
);
const CircleItem = ({ description }) => (
  <div>
    <Circle /> - {description}
  </div>
);

const Note = ({ text, leftArrow, rightArrow }) => (
  <td className="schedule-trip-note text-center word-wrap" width="100%">
    <div>
      {leftArrow && <i className="trip-arrow-left fas fa-arrow-left" />}
      {text}
      {rightArrow && <i className="trip-arrow-right fas fa-arrow-right" />}
    </div>
  </td>
);

export {
  Schedule,
  Panel,
  Line,
  Trip,
  Note,
  SpecialSchedule,
  Legend,
  LegendItem,
  CircleItem,
  DiamondItem,
  SquareItem,
  StarItem,
  Alert,
};
